export const toggleStoreAvailabilityModal = bool => {
	return {
		type: 'toggle-store-availability-modal',
		payload: bool
	};
};
